import { render } from "./ServiceFeatureBlock.vue?vue&type=template&id=633ea8e9&scoped=true"
import script from "./ServiceFeatureBlock.vue?vue&type=script&lang=js"
export * from "./ServiceFeatureBlock.vue?vue&type=script&lang=js"

import "./ServiceFeatureBlock.vue?vue&type=style&index=0&id=633ea8e9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633ea8e9"]])

export default __exports__